<template>
  <div id="LearnRenderer" class="h-screen w-full">

    <!--- TOP PROGRESS BAR START --->
    <div class="absolute w-full z-10">
      <div class="p-8 sm:p-10 md:p-12 lg:p-16">
        <div class="flex items-center justify-center">
          <feather-icon icon="XIcon" svgClasses="h-8 w-8 text-white hover:text-primary cursor-pointer" class="mr-2" @click="$router.back()"/>
          <vs-progress :percent="currentProgress" color="success" class="w-full LearnProgressBar" height="14"></vs-progress>
        </div>
      </div>
    </div>
    <!--- TOP PROGRESS BAR END --->

    <!--- LEARN APP START --->
    <div class="h-screen w-full relative flex items-center justify-center">

      <div v-if="!finishedLesson" class="LearnAppContainer">
        <div class="flex items-center mb-8">
          <span class="text-left">{{ currentChallenge.prompt }}</span>
        </div>

        <div v-if="currentChallenge.type === 'multi_choice'">
          <h2 v-if="currentChallenge.meta.title" class="font-light mb-5">{{ currentChallenge.meta.title }}</h2>
          <div class="grid gap-4" :style="`grid-template-columns: repeat(${currentChallenge.meta.choices.length}, minmax(0, 1fr));`">
            <vx-card class="multiChoiceCard cursor-pointer" v-for="(choice, index) in currentChallenge.meta.choices"
                     @click="multiChoiceSelectOption(index)" :class="choice.selected ? 'cardSelected' : ''">
              <div class="flex items-center justify-center p-1 mb-3" v-if="choice.image" >
                <img draggable="false" :src="choice.image" style="max-width: 12rem;">
              </div>
              <div class="flex items-center justify-center" :class="choice.image ? '' : 'h-full'">
                <h1 class="font-bold">{{ choice.text }}</h1>
              </div>
            </vx-card>
          </div>
        </div>
      </div>

      <div v-if="finishedLesson">
        <div class="flex items-center justify-center">
          <lottie-animation :autoPlay="true"
                            :loop="false"
                            :speed="1" :width="310"
                            path="https://assets4.lottiefiles.com/packages/lf20_01bh9ld2.json"/>
        </div>
        <h1 class="mt-1 font-bold text-center" style="font-size: 3.5rem">Lesson Completed!</h1>
        <h3 class="mt-3 font-light text-center">Great Work, Lets Keep Practicing</h3>

      </div>
    </div>
    <!--- LEARN APP END --->

    <!--- BOTTOM ACTION BAR START --->
    <div v-if="!finishedLesson" :class="`${challengeScore.active ? 'answerDisplay' : ''}`"
         class="bottomActionBar absolute w-full z-10 bottom-0">

      <div v-if="!challengeScore.active" class="p-12 pt-8 pb-8 w-full">
        <div class="flex items-center justify-center w-full">
          <div class="actionButtons flex items-center justify-between">
            <vs-button :disabled="!skipButton" class="skipButton" color="transparent"
                       type="flat" @click="checkAnswer(true)">SKIP
            </vs-button>
            <vs-button :disabled="!checkButton" class="nextButton" @click="checkAnswer">CHECK</vs-button>
          </div>
        </div>
      </div>

      <div v-if="challengeScore.active" class="p-12 pb-2 pt-2 w-full">
        <div class="flex items-center justify-center w-full">
          <div class="actionButtons flex items-center justify-between">
            <div class="flex items-center">
              <lottie-animation :autoPlay="true"
                                :loop="false"
                                :speed="1" :width="challengeScore.correct ? 110 : 70"
                                :path="challengeScore.correct
                                ? 'https://assets1.lottiefiles.com/packages/lf20_pmYw5P.json'
                                : 'https://assets4.lottiefiles.com/private_files/lf30_chkimb7d.json'"/>
              <div>
                <h1 v-if="challengeScore.correct" class="text-success ml-4">Nice Job, Correct!</h1>
                <h1 v-if="!challengeScore.correct" class="text-danger ml-4">Nice Try, Incorrect!</h1>
                <h4 class="text-light mt-2 ml-4" v-if="challengeScore.text">{{ challengeScore.text }}</h4>
              </div>
            </div>

            <vs-button class="nextButton" @click="nextChallenge">CONTINUE</vs-button>
          </div>
        </div>
      </div>


    </div>
    <!--- BOTTOM ACTION BAR END --->

  </div>
</template>

<script>
import LottieAnimation from '@/components/lottie/LottieAnimation'

export default {
  data() {
    return {
      currentChallengeIndex: 0,
      currentChallenge: null,
      checkButton: false,
      challengeScore: {
        active: false,
        correct: false,
        text: ''
      },

      challengesToComplete: [
        {
          "id": "270461066138353664",
          "type": "multi_choice",
          "prompt": "Match the definition to its acronym",
          "meta": {
            "title": "Triple Data Encryption Standard",
            "choices": [
              {
                text: "3DES",
                correct: true,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
              {
                text: "TDES",
                correct: false,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
              {
                text: "3DE$",
                correct: false,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
            ],
            "multiple": false,
            "tts": ""
          }
        },
        {
          "id": "270461066138353664",
          "type": "multi_choice",
          "prompt": "Choose the correct contraption",
          "meta": {
            "title": "What contraption prevents a person from entering a datacenter without proper biometrics",
            "choices": [
              {
                text: "Door Lock",
                correct: false,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
              {
                text: "Pressure Plates",
                correct: false,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
              {
                text: "Man Trap",
                correct: true,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
            ],
            "multiple": false,
            "tts": ""
          }
        },
        {
          "id": "270461066138353664",
          "type": "multi_choice",
          "prompt": "Match the definition to its acronym",
          "meta": {
            "title": "Access Control List",
            "choices": [
              {
                text: "A3L",
                correct: false,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
              {
                text: "ACL",
                correct: true,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
              {
                text: "CLA",
                correct: false,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
            ],
            "multiple": false,
            "tts": ""
          },
        },
        {
          "id": "270461066138353664",
          "type": "multi_choice",
          "prompt": "Select the correct tool below",
          "meta": {
            "title": "What tool is used for port scanning",
            "choices": [
              {
                text: "SHODAN",
                correct: false,
                image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
              {
                text: "WIRESHARK",
                correct: false,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
              {
                text: "NMAP",
                correct: true,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
            ],
            "multiple": false,
            "tts": ""
          },
        },
        {
          "id": "270461066138353664",
          "type": "multi_choice",
          "prompt": "Select the correct tool below",
          "meta": {
            "title": "What tool is a packet analyzer",
            "choices": [
              {
                text: "METASPLOIT",
                correct: false,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
              {
                text: "WIRESHARK",
                correct: true,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
              {
                text: "SENTINEL ONE",
                correct: false,
                // image:  "https://d2pur3iezf4d1j.cloudfront.net/images/b40a713e2c973cb54c3c5bb67ef19af4",
                selected: false
              },
            ],
            "multiple": false,
            "tts": ""
          },
        },
      ],
      challengesCompleted: [],

      finishedLesson: false,

      keyboardShortcuts: false,
      skipButton: true,

    }
  },
  components: {
    LottieAnimation
  },
  computed: {
    currentProgress () {
      console.log(this.challengesToComplete.length)
      return (this.challengesCompleted.length / (this.challengesToComplete.length + this.challengesCompleted.length)) * 100
    }
  },
  methods: {
    keyPressed (e) {
      if(this.keyboardShortcuts === true) {
        console.log(e)
      }
    },
    checkAnswer (skip) {
      if(this.currentChallenge.type === 'gap_fill') return
      if(this.currentChallenge.type === 'multi_choice') return this.multiChoiceMark(skip)
      if(this.currentChallenge.type === 'write') return
    },
    nextChallenge () {
      if(this.challengesToComplete.length === 0) {
        this.lessonCompleteSound.play()
        return this.finishedLesson = true
      }

      this.skipButton = false
      this.currentChallenge = this.challengesToComplete[this.currentChallengeIndex]
      this.checkButton = false
      this.updateChallengeScore(false, false, null)

      setTimeout(() => {
        this.skipButton = true
      }, 1000)
    },
    multiChoiceMark (skip) {
      if(skip === true) {
        this.markedChallenge(false)
        return this.updateChallengeScore(true, false,
          `Correct Answer : ${this.currentChallenge.meta.choices[0].text}`)
      }
      let correct = true
      let text = `Correct Answer : ${this.currentChallenge.meta.choices[0].text}`
      this.currentChallenge.meta.choices.forEach((choice, index) => {
        if(choice.selected !== choice.correct) correct = false
        this.currentChallenge.meta.choices[index].selected = false
      })
      if(correct === true) this.markedChallenge(true)
      if(correct === false) this.markedChallenge(false)
      this.updateChallengeScore(true, correct, text)
    },
    multiChoiceSelectOption (index) {
      if(this.currentChallenge.meta.multiple === false) {
        this.currentChallenge.meta.choices.forEach((choice, choice_index) => {
          this.currentChallenge.meta.choices[choice_index].selected = false
        })
      }

      this.currentChallenge.meta.choices[index].selected = !this.currentChallenge.meta.choices[index].selected
      this.checkButton = this.currentChallenge.meta.choices[index].selected === true;

    },
    markedChallenge (correct) {
      if(correct === false) {
        this.promptIncorrectSound.play()
        this.challengesToComplete.splice(this.currentChallengeIndex, 1)
        this.challengesToComplete.push(this.currentChallenge)
      }
      if(correct === true) {
        this.promptCorrectSound.play()
        this.challengesToComplete.splice(this.currentChallengeIndex, 1)
        this.challengesCompleted.push(this.currentChallenge)
      }
    },
    updateChallengeScore (active, correct, text) {
      this.challengeScore.active = active
      this.challengeScore.correct = correct
      this.challengeScore.text = text
    }
  },
  mounted() {
    this.promptCorrectSound = new Audio('https://d35aaqx5ub95lt.cloudfront.net/sounds/37d8f0b39dcfe63872192c89653a93f6.mp3')
    this.promptIncorrectSound = new Audio('https://d35aaqx5ub95lt.cloudfront.net/sounds/f0b6ab4396d5891241ef4ca73b4de13a.mp3')
    this.lessonCompleteSound = new Audio('https://d35aaqx5ub95lt.cloudfront.net/sounds/2aae0ea735c8e9ed884107d6f0a09e35.mp3')

    this.currentChallenge = this.challengesToComplete[this.currentChallengeIndex]

    window.addEventListener('keypress', this.keyPressed);
  },
  beforeDestroy() {
    window.addEventListener('keypress', this.keyPressed);
  }
}
</script>
<style lang="scss">
#LearnRenderer{
  //  background: #050035;
  .LearnProgressBar {
    background-color: rgba(0, 0, 0, 0.30);
    z-index: 999999;
    max-width: 950px;
  }
  .LearnAppContainer {
    // padding-top: 10%;
    padding-bottom: 8.5%;
    max-width: 850px;
    width: 70%;
    font-size: 32px;
    font-weight: 600;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .multiChoiceCard {
    border: solid #e5e5e5;
    border-width: 1px 1px 1px 1px;
    transition: none;
    &:hover {
      background: rgba(0, 0, 0, 0.15);
    }
    &:active {
      transform:translateY(2px) translateZ(0)
    }
    &.cardSelected {
      background: rgba(24, 153, 214, 0.80);
      border-color: #84d8ff;
    }
    .vx-card__body {
      height: 100%;
    }
    .vx-card__collapsible-content.vs-con-loading__container {
      height: 100%;
    }
  }
  .bottomActionBar {
    min-height: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid rgba(229, 229, 229, 0.25);
    border-width: 2px 0 0 0;
    &.answerDisplay{
      border-color: transparent;
      background: rgba(0, 0, 0, 0.3);
    }
  }
  .actionButtons {
    max-width: 1100px;
    width: 100%;
  }
  .nextButton {
    font-weight: 600;
    font-size: 2rem;
    padding: 10px 40px 10px 40px;
    border-radius: 20px;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;

    &:disabled {
      background: #afafaf!important;
    }
  }
  .skipButton {
    font-weight: 600;
    font-size: 2rem;
    padding: 10px 40px 10px 40px;
    border: 2px solid rgba(229, 229, 229, 0.25)!important;
    color: #FFF!important;
    border-radius: 20px;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;

    &:disabled {
      opacity: 0%;
    }
  }
}


</style>
